export enum TriggerTypes {
  Chevron = 'chevron',
  Button = 'button',
}
